import { Icon } from "@iconify/react";
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import homeFill from "@iconify/icons-eva/home-fill";
import personFill from "@iconify/icons-eva/person-fill";
import settings2Fill from "@iconify/icons-eva/settings-2-fill";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { getProfile } from "../../core/service/users.service";
import { config } from "../../core/service/config.service";

// material
import { alpha } from "@mui/material/styles";
import {
  Button,
  Box,
  Divider,
  MenuItem,
  Typography,
  Avatar,
  IconButton
} from "@mui/material";
// components
import MenuPopover from "../../components/MenuPopover";

// ----------------------------------------------------------------------
import { logout } from "../../core/redux/action/auth";

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState([{}]);

  const { user: currentUser } = useSelector((state) => state.authReducer);

  useEffect(() => {
    const getUserProfile = async (id) => {
      const data = await getProfile(id);
      setUser(data);
    };

    getUserProfile(currentUser?.id);
  }, []);

  const MENU_OPTIONS = [
    {
      label: "Home",
      icon: homeFill,
      linkTo: `/profile/${currentUser?.role}`
    },
    {
      label: "Profile",
      icon: personFill,
      linkTo: `/profile/${currentUser?.role}`
    },
    // {
    //   label: "Settings",
    //   icon: settings2Fill,
    //   linkTo: "#"
    // }
  ];

  const {
    email,
    personal_infomation,
    postdoc_educational_background,
    postdoctoral_information,
    working_experience,
    role
  } = user;

  const fullName = `${personal_infomation?.name_en} ${personal_infomation?.surname_en}`;

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const logOut = () => {
    dispatch(logout());
    navigate("/", { replace: true });
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar
          src={
            personal_infomation?.photo
              ? `${config.host_api}user/photo/${personal_infomation?.photo}`
              : null
          }
          // alt="photoURL"
        />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {fullName}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {currentUser?.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: "body2", py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth color="inherit" variant="outlined" onClick={logOut}>
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
